<template>
  <div class="row card-collapse">
    <div class="col-12 form-patient-base">
      <titan-form ref="patientBase"
                  :schema="schema"
                  v-on:saveData="$emit('saveData')"
                  v-on:beforeSave="$emit('validate')"
                  :showMessage="false"
                  :model="formData"
                  :newItem="newItem"
                  :editable="editable"
                  :show-action-button="showActionButton"
      />
<!--      <button type="button" class="btn second-button" @click="$refs.patientAddress.saveData()"-->
<!--              :class="{'btn-success': newItem, 'btn-primary': !newItem, }">-->
<!--        <font-awesome-icon :icon="newItem === true ? 'plus' : 'check'"/>-->
<!--        <span v-if="!newItem">{{t('Save')}}</span>-->
<!--        <span v-if="newItem">{{t('Create')}}</span>-->
<!--      </button>-->
    </div>
    <div class="col-12 form-patient-address">
      <titan-form ref="patientAddress"
                  :schema="patientAddress"
                  v-on:saveData="$emit('saveData')"
                  v-on:beforeSave="$emit('validate')"
                  :showMessage="false"
                  :model="formData"
                  :newItem="newItem"
                  :editable="editable"
                  :show-action-button="showActionButton"
      >
        <div style="line-height: 18px;" slot="patientAddress-item-header" slot-scope="slotData">
          <div>{{slotData.item.street}}</div>
          <div>{{slotData.item.zip}}, {{slotData.item.city}}</div>
          <div v-if="slotData.item.country !== undefined && slotData.item.country !== null">
            {{slotData.item.country.name}}
          </div>
        </div>
      </titan-form>
<!--      <button type="button" class="btn second-button" @click="$refs.patientAddress.saveData()"-->
<!--              :class="{'btn-success': newItem, 'btn-primary': !newItem, }">-->
<!--        <font-awesome-icon :icon="newItem === true ? 'plus' : 'check'"/>-->
<!--        <span v-if="!newItem">{{t('Save')}}</span>-->
<!--        <span v-if="newItem">{{t('Create')}}</span>-->
<!--      </button>-->
    </div>
  </div>
</template>
<script>
    import TitanForm from '../../../core/Form/Form'
    import VueFormGenerator from "vue-form-generator";
    import {validateMultipleForms} from '../../../core/Libs/utils';

    export default {
        components: {
            TitanForm,
        },
        props: {
            formData: {
                type: Object,
                required: true,
            },
            newItem: {
                type: Boolean,
                required: false,
                default: false,
            },
            editable: {
                type: Boolean,
                required: false,
                'default': true
            },
            showActionButton: {
                type: Boolean,
                required: false,
                'default': true
            }
        },
        mounted() {
            this.setBodySurface();
            this.setBmi();
        },
        computed: {
            panel() {
                return this.$store.state.account.user.panel;
            },
            insuranceCode() {
                return !this.formData.insurance ? null : this.formData.insurance.code;
            }
        },
        watch: {
            insuranceCode(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                    }, 50);
                }
            }
        },
        methods: {
            setBodySurface() {
                this.formData.bodySurface = parseFloat((0.167 * Math.sqrt(this.formData.height / 100 * this.formData.weight)).toFixed(2));
            },
            setBmi() {
                this.formData.bmi = parseFloat((this.formData.weight / Math.pow(this.formData.height / 100,2)).toFixed(2));
            },
            isValid() {
                return validateMultipleForms([
                    this.$refs.patientBase,
                    this.$refs.patientAddress,
                ]);
            },
            getYears() {
                const year = new Date().getFullYear();
                let out = [];
                for (let i = year; i >= year - 99; i--) {
                    out.push({id: i, name: i});
                }
                return out;
            },
        },
        data() {
            return {
                schema: [
                    {
                        name: this.t('Base patient info'),
                        type: 'main',
                        fields: [
                            {
                                type: 'titanSelect',
                                codeBook: 'insurances',
                                label: this.t('Insurances'),
                                styleClasses: 'col-12',
                                model: 'insurance',
                                valueLabel: 'insuranceName',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.editable === false,
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Title prefix'),
                                styleClasses: 'col-2',
                                model: 'titlePrefix',
                                required: false,
                                max: 40,
                                validator: VueFormGenerator.validators.string,
                                disabled: this.editable === false,
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Name'),
                                styleClasses: 'col-4',
                                model: 'name',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.editable === false,
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Surname'),
                                styleClasses: 'col-4',
                                model: 'surname',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.editable === false,
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Title sufix'),
                                styleClasses: 'col-2',
                                model: 'titleSufix',
                                required: false,
                                max: 40,
                                validator: VueFormGenerator.validators.string,
                                disabled: this.editable === false,
                            }, {
                                type: 'titanSelect',
                                values: this.getYears(),
                                constant: true,
                                label: this.t('Birth year'),
                                styleClasses: 'col-6',
                                model: 'birthYear',
                                required: false,
                                validator: VueFormGenerator.validators.number,
                                disabled: this.editable === false,
                            }, {
                                type: 'titanBirthNumber',
                                label: this.t('Birth number'),
                                styleClasses: 'col-6',
                                model: 'birthNumber',
                                max: 11,
                                required: true,
                                validator: VueFormGenerator.validators.string,
                                disabled: this.editable === false,
                            }, {
                                type: 'input',
                                inputType: 'number',
                                label: this.t('Weight'),
                                styleClasses: 'col-3',
                                model: 'weight',
                                required: true,
                                validator: VueFormGenerator.validators.number,
                                disabled: this.editable === false,
                                onChanged: () => {
                                    this.setBodySurface();
                                    this.setBmi();
                                }
                            },
                            {
                                type: 'input',
                                inputType: 'number',
                                label: this.t('Height') + ' (cm)',
                                styleClasses: 'col-3',
                                model: 'height',
                                required: this.isNotIntKar(),
                                validator: VueFormGenerator.validators.number,
                                disabled: false,
                                onChanged: () => {
                                    this.setBodySurface();
                                    this.setBmi();
                                },
                                visible: () => {
                                    // return (this.insuranceCode === 25 && (this.panel === null || this.panel.id === 1))
                                    return true
                                }
                            },
                            {
                                type: 'input',
                                inputType: 'number',
                                label: this.t('BMI'),
                                styleClasses: 'col-3',
                                model: 'bmi',
                                required: this.isNotIntKar(),
                                validator: VueFormGenerator.validators.number,
                                disabled: true,
                                visible: () => {
                                    return true
                                }
                            },
                            {
                                type: 'input',
                                inputType: 'number',
                                label: this.t('Body surface area') + ' (m<sup>2</sup>)',
                                styleClasses: 'col-3',
                                model: 'bodySurface',
                                required: this.isNotIntKar(),
                                validator: VueFormGenerator.validators.number,
                                disabled: true,
                                visible: () => {
                                    // return (this.insuranceCode === 25 && (this.panel === null || this.panel.id === 1))
                                    return true
                                }
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Phone'),
                                styleClasses: 'col-6',
                                model: 'phone',
                                required: false,
                                disabled: this.editable === false,
                            }, {
                                type: 'input',
                                inputType: 'email',
                                label: this.t('E-mail'),
                                styleClasses: 'col-6',
                                model: 'email',
                                required: false,
                                validator: VueFormGenerator.validators.email,
                                disabled: this.editable === false,
                            }
                        ]
                    }
                ],
                patientAddress: [
                    {
                        name: this.t('Address'),
                        type: 'oneToMany',
                        model: 'patientAddress',
                        listModel: 'street',
                        acceptAction: true,
                        disabled: this.editable === false,
                        min: 1,
                        fields: [
                            {
                                type: 'titanSelect',
                                label: this.t('Type'),
                                values: [
                                    {
                                        id: 'permanent',
                                        name: this.t('Permanent residence'),
                                    }, {
                                        id: 'temporary',
                                        name: this.t('Temporary residence'),
                                    }
                                ],
                                constant: true,
                                model: 'type',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.editable === false,
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Street'),
                                model: 'street',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.editable === false,
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('City'),
                                model: 'city',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.editable === false,
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Zip'),
                                model: 'zip',
                                required: true,
                                validator: VueFormGenerator.validators.string,
                                disabled: this.editable === false,
                            }, {
                                type: 'titanSelect',
                                codeBook: 'country',
                                label: this.t('Country'),
                                model: 'country',
                                default: 1,
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.editable === false,
                            }
                        ]
                    }
                ],
            }
        }
    }
</script>

<style lang="scss">
  .second-button {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/patients/form.vue